module.exports = __webpack_public_path__ + "img/noneproduct.png";